module.exports = __webpack_public_path__ + "img/odovzdanie-bytov.419702b1.svg";